import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { DensityLarge, DensityMedium, DensitySmall } from '@mui/icons-material';

import { useState } from 'react';
import { useLocalization } from '../../../providers/LocalizationProvider';

function DensityToggle({ onDensityChange, ...rest }) {
  const { formatMessage } = useLocalization();
  const [density, setDensity] = useState('comfortable');

  const handleToggleDensePadding = () => {
    let nextDensity;
    if (density === 'comfortable') {
      nextDensity = 'compact';
    } else if (density === 'compact') {
      nextDensity = 'spacious';
    } else {
      nextDensity = 'comfortable';
    }
    setDensity(nextDensity);
    onDensityChange(nextDensity);
  };

  return (
    <Tooltip
      arrow
      title={formatMessage({
        id: 'DENSITY_SWITCHER_TOOLTIP',
        defaultMessage: 'Toggle table density',
      })}>
      <IconButton
        variant="contained"
        size="small"
        onClick={handleToggleDensePadding}
        {...rest}
        title={undefined}>
        {(() => {
          if (density === 'compact') {
            return <DensitySmall />;
          }
          if (density === 'comfortable') {
            return <DensityMedium />;
          }
          return <DensityLarge />;
        })()}
      </IconButton>
    </Tooltip>
  );
}

export default DensityToggle;
